import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { Col, Container, Row } from "reactstrap"

//Import sections
import CarParkList from "./CarParkList"
import CarParkCreate from "./CarParkCreate"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

//redux
import { useSelector, useDispatch } from "react-redux"

const CarParkView = props => {
  const dispatch = useDispatch()
  const [selectedCarPark, setSelectedCarPark] = useState(null)
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Carparks | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Carparks" breadcrumbItem="Manage Carparks" />
          <Row>
            <Col lg="12">
              <CarParkList
                role={selectedCarPark}
                setSelectedCarPark={setSelectedCarPark}
              />
            </Col>

            {/* <Col lg="6">
              <CarParkCreate role={selectedCarPark} history={""} />
            </Col> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

CarParkView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(CarParkView)
